/* eslint-disable jsx-a11y/alt-text */
import React from "react";
import { Link } from "react-router-dom";
import cn from "classnames";

import Constants from "app_constants";
import Utils from "utils";
import Theme from "./theme";

const addPlaceholder = (e) => (e.target.src = "job_img.png");

const JobAdBox = ({ jobAd, isGrid = false }) => {
  const isAdmin = localStorage.getItem("isAdmin") === "true";

  return (
    <Theme isGrid={isGrid}>
      {(isAdmin || jobAd.published) && (
        <div onClick={() => window.scrollTo(0, 0)}>
          <Link to={`/job/${jobAd._id}`}>
            <div className="box jobAd">
              <div className="companyLogo">
                <figure className="image is-48x48">
                  <img
                    src={jobAd.company.logo || "/job_img.png"}
                    onError={addPlaceholder}
                  />
                </figure>
              </div>

              <div className="info">
                <p>{jobAd.company.name}</p>
                <b
                  className={cn(
                    "title",
                    "is-hidden-touch",
                    isGrid ? "is-6" : "is-4"
                  )}
                >
                  {jobAd.title}
                </b>
                <b className="jobTitle is-hidden-desktop">{jobAd.title}</b>
                {jobAd.compensation && (
                  <b className={cn({ "is-hidden-desktop": !isGrid })}>
                    {jobAd.compensation}
                  </b>
                )}
                {isGrid && <p>{Constants.jobCategories[jobAd.category]}</p>}
                {!isGrid && (
                  <p className="subInfo">
                    {Utils.parseJobType(jobAd.type)} -{" "}
                    {jobAd.regionalRestrictions
                      ? jobAd.regionalRestrictions
                      : "Worlwide"}
                  </p>
                )}
              </div>
              {!isGrid && (
                <div className="rightSection is-hidden-touch">
                  <div className="date-salary">
                    <p className="date">
                      {new Date(jobAd.date).toLocaleDateString()}
                    </p>
                    <b>{jobAd.compensation}</b>
                  </div>

                  <div className="labels">
                    <p className="tag is-info is-medium">
                      {Constants.jobCategories[jobAd.category]}
                    </p>

                    {/* jobAd.featured && <p className="tag is-success is-medium">Featured</p> */}
                  </div>
                </div>
              )}
            </div>
          </Link>
        </div>
      )}
    </Theme>
  );
};

export default JobAdBox;
